import { css } from '@emotion/react';

/**
 * @deprecated use Chakra UI
 */
export const lineClampStyles = (lines) => css`
  display: -webkit-box;
  -webkit-line-clamp: ${lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
